import api from 'api';

export const loadSmartRulesGrid = api('POST /api/smart-rules/grid');

export const loadSmartRule = api('GET /api/smart-rules/:id');

export const loadSmartRuleDetails = api('GET /api/smart-rules/:id/details');
export const loadSmartRuleResults = api('GET /api/smart-rules/:id/results');
export const loadSmartRuleActionsLog = api(
  'POST /api/smart-rules/:id/actions-log'
);

export const createSmartRule = api('POST /api/smart-rules');
export const startSmartRule = api('PUT /api/smart-rules/:id/start');
export const stopSmartRule = api('PUT /api/smart-rules/:id/stop');
export const editSmartRule = api('PUT /api/smart-rules/:id/edit');
export const approveSmartRule = api('PUT /api/smart-rules/:id/approve');
export const rejectSmartRule = api('PUT /api/smart-rules/:id/reject');
export const actionApproveSmartRule = api(
  'PUT /api/smart-rules/:id/action-approve'
);
export const actionRejectSmartRule = api(
  'PUT /api/smart-rules/:id/action-reject'
);
export const removeSmartRule = api('DELETE /api/smart-rules/:id/delete');

export const bulkStartSmartRule = api('POST /api/smart-rules/bulk/start');
export const bulkStopSmartRule = api('POST /api/smart-rules/bulk/stop');
export const bulkRemoveSmartRule = api('POST /api/smart-rules/bulk/delete');

export const sendSmartRuleActionCallback = api(
  'GET /api/smart-rules/rules/:action/:token'
);
